// src/app/application-submitted/application-submitted.component.ts
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-application-submitted',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './application-submitted.component.html',
  styleUrls: ['./application-submitted.component.css']
})
export class ApplicationSubmittedComponent {

  constructor(private router: Router, private translate: TranslateService) { }

  backToLogin(): void {
    this.router.navigate(['/login']);
  }
}
